module.exports = __webpack_public_path__ + "img/symbol_9.6df868b2.png";